import React from "react";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import styled from "styled-components";

const NumberInputWrapper = styled.div`
  display: block;
  font-family: "Roboto Mono";

  label {
    font-family: "Roboto Mono",
    display: block;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 300;
    color: #7f7f7f;
    margin: 30px 0 10px;
  }

  input {
    background: black;
    border: 1px solid #2d2e30;
    height: 60px;
    font-size: 16px;
    line-height: 60px;
    color: white;
    display: block;
    font-size: 26px;
    font-weight: 300;
    font-weight: bold;
    text-transform: uppercase;
    width: 100%;
    padding: 0 20px;

    @media (max-width: 767.98px) {
      font-size: 20px;
    }

    &:active, &:focus {
      border-color: #ff5000;
      outline: none;
    }
  }

  span {
    font-family: "Roboto Mono";
    color: #ff5000;
    font-size: 40px;
  }
`;

const NumberInput = ({
  summary,
  disabled,
  displayType,
  defaultValue,
  value,
  name,
  onChange,
  selectData,
  title
}) => {
  const onValueChange = values => {
    onChange(name, values);
  };

  return (
    <NumberInputWrapper summary={summary}>
      <label>{title}</label>
      <NumberFormat
        disabled={disabled}
        allowNegative={false}
        defaultValue={defaultValue}
        value={value}
        thousandSeparator=" "
        displayType={displayType}
        decimalScale={summary ? 0 : 2}
        decimalSeparator=","
        suffix={" ZŁ"}
        onValueChange={onValueChange}
      />
    </NumberInputWrapper>
  );
};

NumberInput.defaultProps = {
  disabled: false,
  displayType: "input",
  defaultValue: "",
  name: "",
  onChange: () => {},
  title: ""
};

NumberInput.propTypes = {
  disabled: PropTypes.bool,
  displayType: PropTypes.string,
  selectData: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  title: PropTypes.string
};

export default NumberInput;
